<template>
    <div class="product-release-detail">
        <v-layout>
            <v-flex sm12 class="ma-4">
                <v-card>
                    <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                        Image
                    </v-card-title>
                    <v-card-text>

                        <v-img
                                :src="require('../../assets/Testbild.jpg')"
                                aspect-ratio="1"
                                contain
                        >
                        </v-img>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary">Check</v-btn>
                        <v-btn flat color="red">Reset</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex sm4 class="ma-4">
                <v-card>
                    <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                        Details
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <h3>Basisdaten</h3>
                            <v-text-field
                                    v-model="number"
                                    label="product number"
                                    required
                            ></v-text-field>
                            <v-text-field
                                    v-model="customer_number"
                                    label="customer product number"
                            ></v-text-field>
                            <v-text-field
                                    v-model="description"
                                    label="description"
                            ></v-text-field>
                            <v-text-field
                                    v-model="extra_description"
                                    label="extra description"
                            ></v-text-field>

                            <h3>Maße & Material</h3>
                            <v-text-field
                                    v-model="extra_dimension"
                                    label="extra dimension"
                            ></v-text-field>
                            <v-text-field
                                    v-model="material"
                                    label="material"
                            ></v-text-field>
                            <v-text-field
                                    v-model="width"
                                    label="width"
                                    suffix="mm"
                            ></v-text-field>
                            <v-text-field
                                    v-model="height"
                                    label="height"
                                    suffix="mm"
                            ></v-text-field>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex sm8 class="ma-4">
                <v-card>
                    <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                        Protokoll
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                class="elevation-1"
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.forename }} {{ props.item.surname }}</td>
                                <td>{{ props.item.department }}</td>
                                <td>{{ props.item.alterantive_department }}</td>
                                <td>{{ props.item.actions }}</td>
                            </template>
                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<style>
    .scroll {
        overflow-y: auto;
    }
</style>
<script>
    export default {
        data: () => ({
            valid: false,

            name: '',
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],

            department: ['Programming'],
            department_items: [
                'SHEQ',
                'SHEQ (Start s)',
                'SHEQ (Start)',
                'SHEQ(s)'
            ],

            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],

            standard: false,
            show_protocol: false,


            headers: [
                { text: 'Name', align: 'left', sortable: false, value: 'surname'},
                { text: 'Abteilung', value: 'department' },
                { text: 'Datum', value: 'alterantive_department' },
                { text: 'Von Abteilung', value: 'mail' }
            ],
            desserts: [
                {
                    forename: 'Dittrich',
                    surname: 'Dennis',
                    department: 'Entwicklung',
                    alterantive_department: 'SHWQ(s) (Spezialgase)',
                    mail: 'WTO, Druckvorstufe',
                    represented_by_user: 'Ja',
                    actions: 'ED'
                },
                {
                    forename: 'Dittrich',
                    surname: 'Dennis',
                    department: 'Entwicklung',
                    alterantive_department: 'SHWQ(s) (Spezialgase)',
                    mail: 'WTO, Druckvorstufe',
                    represented_by_user: 'Ja',
                    actions: 'ED'
                }
            ]

        })
    }
</script>

